<template>
   <el-upload
       accept="image/jpeg, image/jpg, image/png, image/webp, image/gif, image/heic"
       action="#"
      list-type="picture-card"
      :limit="sectionType === 'gallery' ? 10 : 1"
      :auto-upload="false"
      :file-list="files"
      :on-change="handleChange"
  >
    <i slot="default" class="el-icon-plus"></i>
    <div slot="file" slot-scope="{file}">
      <img class="el-upload-list__item-thumbnail" :src="file.url" alt="Image présentation">
      <span class="el-upload-list__item-actions">
          <span class="el-upload-list__item-delete" @click="removeFile(file)">
            <i class="el-icon-delete"></i>
          </span>
        </span>
    </div>
  </el-upload>
</template>

<script>
import { mapGetters } from 'vuex'
import fileTypeValidationMixin from '@/mixins/fileTypeValidationMixin'

export default {
  name: 'UploadDBKS',
  mixins: [fileTypeValidationMixin],
  props: {
    sectionType: {
      type: String,
      required: true
    }
  },
  data () {
    return {
      allowedImageTypes: [
        'image/jpeg',
        'image/jpg',
        'image/png',
        'image/webp',
        'image/gif',
        'image/heic'
      ],
    }
  },
  computed: {
    ...mapGetters('etablishmentSheet', ['getFilesByType']),
    files () {
      return this.getFilesByType(this.sectionType)
    }
  },
  methods: {
    handleChange (file, fileList) {
      // Validation du type de fichier
      if (!this.validateFileType(file, fileList, this.allowedImageTypes, {
        errorMessage: 'Format non autorisé. Formats acceptés: JPG, PNG, WebP, GIF, HEIC',
        formatsList: 'JPG, PNG, WebP, GIF, HEIC'
      })) {
        return
      }
      // Si validation OK, dispatch vers le store
      this.$store.dispatch('etablishmentSheet/addFile', { type: this.sectionType, file: file })
    },
    removeFile (file) {
      this.$store.dispatch('etablishmentSheet/removeFile', { type: this.sectionType, file: file })
    },
    handleDownload (file) {
      this.$store.dispatch('etablishmentSheet/uploadPhotoDBKS', { type: this.sectionType, file: file })
    }
  }
}
</script>
